import ArchiveListPage from './ArchiveListPage'

export default ArchiveListPage
